import { createSlice } from "@reduxjs/toolkit";
import { editProfile } from "redux/actions/profile";

export interface ProfileSliceInterface {
  loading:boolean
}

const initialState:ProfileSliceInterface = {
  loading:false,
}

export const profileSlice = createSlice({
  name: "profileSlice",
  initialState,
  reducers: {},
  extraReducers : (builder) => {
     // * update Profile
     builder.addCase(editProfile.pending, (state, action) => {
      state.loading = true
    })
    builder.addCase(editProfile.rejected, (state, action) => {
      state.loading = false
    })
    builder.addCase(editProfile.fulfilled, (state, action) => {
      state.loading = false
    })
  }
})

export default profileSlice.reducer